import {FC} from "react";
import startCase from "lodash-es/startCase";

type TrialConfirmationProps = {
    type: "audio" | "video"
}

const TrialConfirmation: FC<TrialConfirmationProps> = ({type}) => (
    <>
        <p>
            {startCase(type)}-secties zijn niet beschikbaar voor Brons-abonnementen. Wanneer u besluit door te gaan met
            het toevoegen  van deze {type}-sectie, dan bent u uitgesloten van het Brons-abonnement en is het
            Zilver-abonnement uw enige optie.
        </p>
        <p>
            Weet u zeker dat u door wilt gaan met het toevoegen van deze {type}-sectie?
        </p>
    </>
)

export default TrialConfirmation
